import styled from 'styled-components';

import colors from 'pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '../../styles/LandingPageStyles';

const LandingFooterContainer = styled.div`
  
    color: ${colors.grayscaleCoolGray01};
    letter-spacing: .2px;
    position: absolute;
    text-align: center;
    width: 100%;

    a {
        color: ${colors.grayscaleCoolGray01};
        text-decoration: none;
    }

    /*- DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}) {
        bottom: 9px;
        font-size: 12px;
        letter-spacing: -.3px;
        margin-left: -1px;
        text-decoration: 0 0 1px ${colors.wsWhite};
    }

    /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}) {
        bottom: 4px;
        font-size: 11px;
        letter-spacing: 0px;
        text-decoration: 0 0 1px ${colors.wsWhite};
    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}) {
        bottom: 3px;
        font-size: 12px;
        letter-spacing: -.25px;
        text-decoration: 0 0 0;
    }

    @media screen and (max-width: 350px) {
    
        .hide-very-small {
            display: none;
        }

        .footer-links {
            display: block;
        }
    }

    
`;

export default LandingFooterContainer;


// WEBPACK FOOTER //
// ./src/components/LandingFooter/LandingFooterStyles.js